<template>
  <div id="reset-password-layout">
    <navbar />
    <div class="slot-wrapper">
      <slot/>
    </div>
    <footer-copyright-v2 />
  </div>
</template>

<script>

import FooterCopyrightV2 from '@/components/FooterCopyrightV2'
import Navbar from '@/components/navbar/NavbarResetPassword'

export default {
  components: {
    FooterCopyrightV2,
    Navbar
  }
}
</script>

<style scoped>
#reset-password-layout {
  background-color: var(--color-neutral-400);
  height: 100%;
  position: relative;
}

@media (max-width: 512px) {
  #reset-password-layout {
    background-color: var(--color-neutral-100);
  }
}
</style>
